import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Autocomplete, Box, Grid, TextField, Typography } from "@mui/material";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { getServiceCity } from "redux/actions/UserServiceCity";
import {
  getBaseFuel,
  getRateCard,
  postRateCard,
} from "redux/actions/UserRateCard";
import { getCar } from "redux/actions/UserCar";
import CommonEditableTable from "components/commonEditableTable/CommonEditableTable";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import Loader from "components/loader/Loader";
import RateCardTab from "./RateCardTab";

function RateCard() {
  const ref = useRef(null);
  const rateCardData = useSelector(
    (state) => state?.userRateCard?.userRateCard?.data
  );
  const baseFuelData = useSelector(
    (state) => state?.userBaseFuel?.userBaseFuel?.data
  );
  const loader = useSelector((state) => state?.userRateCard?.loading);
  const carData = useSelector((state) => state?.userCar?.userCar?.data);
  const carLoading = useSelector((state) => state?.userCar?.loading);
  const oneWayTrip = [
    { name: "Ride", id: 1 },
    { name: "Rental", id: 2 },
  ];
  let SUV = [];
  SUV = carData?.body?.map((e) => ({
    id: e.id,
    name: e.carType,
  }));
  const locationData = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );
  const locationLoading = useSelector(
    (state) => state?.userServiceCity?.loading
  );
  let Location = [];
  Location = locationData;
  const [value, setValue] = useState(oneWayTrip[0]);
  const [suvValue, setSuvValue] = useState({});
  const [location, setLocation] = useState({});
  const [inputValue, setInputValue] = useState("");
  const [inputvaluesuv, setInputValueSuv] = useState("");
  const [fuelBase, setFuelBase] = useState(
    baseFuelData?.baseFuelPrice || "100"
  );
  const [isEditable, setIsEditable] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getCar());
    dispatch(getServiceCity());
  }, []);
  useEffect(() => {
    setFuelBase(baseFuelData?.baseFuelPrice);
  }, [baseFuelData]);

  useEffect(() => {
    if (SUV?.length > 0 && Location?.length > 0) {
      setSuvValue(SUV[0]);
      setLocation(Location[0] || {});
      const data = {
        carId: SUV[0]?.id,
        type: oneWayTrip[0]?.id,
        baseFuelPrice: 59,
        location: Location[0]?.id,
      };
      dispatch(getRateCard(data));
      dispatch(getBaseFuel({ location: Location[0]?.id }));
    }
  }, [carData, locationData]);

  useEffect(() => {
    if (SUV?.length > 0) {
      const data = {
        carId: suvValue?.id,
        type: value?.id,
        baseFuelPrice: parseFloat(fuelBase),
        location: location?.id,
      };
      dispatch(getRateCard(data));
      dispatch(getBaseFuel({ location: location?.id }));
    }
  }, [suvValue, value, location]);

  const handleFuelBaseChange = (event) => {
    setFuelBase(event.target.value);
  };

  const handleEditClick = () => {
    setIsEditable(true); // Toggle editable state
    ref.current.disabled = false;
    ref.current.focus();
  };

  const handleBlur = () => {
    setIsEditable(false); // Disable editable state on blur
    const val = {};
    onSubmitt(val);
  };

  const breadcrumbPaths = [
    { name: "Rate Card", url: "", className: "colorBlue" },
  ];

  const onSubmitt = (data) => {
    const dataList = {
      ...data,
      carType: suvValue?.id,
      type: value?.id,
      baseFuelPrice: parseFloat(fuelBase),
      location: location?.id,
    };
    dispatch(postRateCard(dataList));
  };

  const handleChange = (newValue) => {
    setValue({ ...value, id: parseInt(newValue) });
  };

  return (
    <div>
      <CommonBreadCrumb paths={breadcrumbPaths} />
      {loader ? (
        <Loader />
      ) : (
        <div className="borderStyle">
          <Typography className="colorGrey font18 fontNormal tableHeading alignItem marginBlock10">
            Rate Card Details
          </Typography>

          {/* ---Filter Section--- */}
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignitem="center"
            className="marginBlock30 paddingInline40"
          >
            <Grid item md={2.7} sm={6} xs={12} className="bgLightGrey">
              <Autocomplete
                value={value}
                disableClearable
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue);
                }}
                onChange={(event, value) => {
                  if (value) setValue(value);
                  else setValue({ id: "", name: "" });
                }}
                id="controllable-states-demo"
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
                getOptionLabel={(option) => option.name}
                options={oneWayTrip}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Trip" />
                )}
              />
            </Grid>

            <Grid item md={2.7} sm={6} xs={12} className="bgLightGrey">
              <Autocomplete
                value={suvValue?.name ? suvValue : null}
                onChange={(event, value) => {
                  if (value) setSuvValue(value);
                  else setSuvValue({ id: "", name: "" });
                }}
                disableClearable
                inputvaluesuv={inputvaluesuv}
                onInputChange={(event, newInputValue) => {
                  setInputValueSuv(newInputValue);
                }}
                id="controllable-states-demo"
                options={SUV?.length > 0 ? SUV : []}
                getOptionSelected={(option, value) =>
                  option.name === value.name
                }
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Category" />
                )}
              />
            </Grid>

            <Grid item md={2.7} sm={6} xs={12} className="bgLightGrey">
              <Autocomplete
                value={location?.name ? location : null}
                onChange={(event, value) => {
                  if (value) setLocation(value);
                  else setLocation({ id: "", name: "" });
                }}
                disableClearable
                getOptionLabel={(option) => option.name}
                id="controllable-states-demo"
                options={Location?.length > 0 ? Location : []}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Location" />
                )}
              />
            </Grid>
            <Grid
              item
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              md={2.7}
              sm={6}
              xs={12}
              className="bgLightGrey"
            >
              <Box item xs={12} className="flexAlignCenter">
                <Typography> Base Fuel Rate <span className="marginLeft10">₹</span></Typography>
              
              <Box item xs={5} className="baseFuel">
                <input
                  type="text"
                  placeholder="Base Fuel"
                  name="fuelBase"
                  id="input-with-icon-adornment"
                  value={fuelBase}
                  className={`${!isEditable ? "colorBlack" : "colorBlue"}`}
                  onChange={handleFuelBaseChange}
                  disabled={!isEditable}
                  onBlur={() => {
                    handleBlur();
                  }}
                  ref={ref}
                />
                </Box>
              {!isEditable && (
                <Box>
                  <BorderColorOutlinedIcon
                    onClick={() => handleEditClick()}
                    className="cursor"
                  />
                  </Box>
              )}
              </Box>
            </Grid>
          </Grid>
          {(value?.id === 2 || value?.id === 3) && (
            <RateCardTab
              rateCardData={rateCardData}
              onSubmitData={onSubmitt}
              tripType={value}
              handleChange={handleChange}
            />
          )}
          {value?.id === 1 && !carLoading && !locationLoading && (
            <CommonEditableTable
              rateCardData={rateCardData}
              onSubmitData={onSubmitt}
              tripType={value}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default RateCard;
